import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { throttle } from 'throttle-debounce';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-sticky.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const THROTTLE_DELAY = 100;
const DEFAULT_HEIGHT = 'auto';
const DEFAULT_WIDTH = '100%';
const DEFAULT_ZINDEX = 1;
class EGDSSticky extends React.PureComponent {
  static baseClassName = 'uitk-sticky';
  observer;
  stickyRef;
  stickyChildRef;
  resizeObserver;
  childResizeObserver;
  constructor(props) {
    super(props);
    this.state = {
      fixed: false
    };
    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleResize = throttle(THROTTLE_DELAY, this.handleResize.bind(this), {
      debounceMode: false
    });
    this.stickyRef = React.createRef();
    this.stickyChildRef = React.createRef();
  }
  componentDidMount() {
    const options = {
      threshold: 1.0
    };
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.handleResize(this.stickyRef);
      });
      this.childResizeObserver = new ResizeObserver(() => {
        this.handleResize(this.stickyChildRef);
      });
      this.resizeObserver.observe(this.stickyRef.current);
      this.childResizeObserver.observe(this.stickyChildRef.current);
    } else {
      window.addEventListener('resize', () => {
        this.handleResize(this.stickyRef);
      });
    }
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersection, options);
      this.observer.observe(this.stickyRef.current);
    }
  }
  componentWillUnmount() {
    if (this.observer) {
      this.observer.unobserve(this.stickyRef.current);
    }
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.stickyRef.current);
    } else {
      window.removeEventListener('resize', () => {
        this.handleResize(this.stickyRef);
      });
    }
    if (this.childResizeObserver) {
      this.resizeObserver.unobserve(this.stickyChildRef.current);
    }
  }
  handleIntersection(entries) {
    const {
      onFixed
    } = this.props;
    const entry = entries.shift();
    const isFixed = !entry || entry.boundingClientRect.top < 0;
    this.setState({
      fixed: isFixed,
      height: entry ? entry.boundingClientRect.height : DEFAULT_HEIGHT,
      width: entry ? entry.boundingClientRect.width : DEFAULT_WIDTH
    });
    if (onFixed) {
      onFixed(isFixed);
    }
  }
  handleResize(ref) {
    if (ref.current) {
      const {
        height,
        width
      } = ref.current.getBoundingClientRect();
      this.setState({
        height,
        width
      });
    }
  }
  render() {
    const {
      fixed,
      height,
      width
    } = this.state;
    const {
      zIndex,
      hidden,
      children
    } = this.props;
    const classes = getClassNameList(EGDSSticky.baseClassName, {
      [`${EGDSSticky.baseClassName}-hidden`]: hidden
    }, {
      [`${EGDSSticky.baseClassName}-fixed`]: fixed
    });
    const wrapperStyle = {
      height: hidden ? 0 : height /* stylelint-disable */
    };
    const innerStyle = {
      width,
      zIndex: zIndex || DEFAULT_ZINDEX
    };
    return jsx("div", {
      ref: this.stickyRef,
      className: classes,
      style: wrapperStyle,
      children: jsx("div", {
        className: getClassNameList(`${EGDSSticky.baseClassName}-inner`),
        style: innerStyle,
        ref: this.stickyChildRef,
        children: children
      })
    });
  }
}
export { EGDSSticky };